import { FromGamePostMessage } from '../../enums';
import { toggleFullscreen } from '../../helpers';
import { LaunchData } from '../../models';
import { IntegrationBase } from './base';
import { env } from '../../environment';

export class MonitorIntegration extends IntegrationBase {

  public generateLaunchUrl(data: LaunchData): string {

    const { urlPrefix, gameId, gameTypeId, partnerId, culture, disableLoader, url: launchUrl } = data;

    const urlString = launchUrl || `${env.origin}/${urlPrefix}/`;

    const url = new URL(urlString);

    url.searchParams.set('partnerId', `${partnerId}`);
    url.searchParams.set('culture', `${culture}`);
    url.searchParams.set('gameId', `${gameId}`);
    url.searchParams.set('gameTypeId', `${gameTypeId}`);

    if (disableLoader) {
      url.searchParams.set('disableLoader', `${disableLoader}`);
    }

    return url.toString();
  }

  public registerFullscreenChangeListener() {
    const htmlElement = document.documentElement;
    const sendFullscreenUpdate = this.rootStore.postMessageStore.sendFullscreenUpdate.bind(this.rootStore.postMessageStore);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'F11') {
        e.preventDefault();
        this.handleToggleFullScreen();
      }
    });

    htmlElement.addEventListener('fullscreenchange', sendFullscreenUpdate);
    htmlElement.addEventListener('mozfullscreenchange', sendFullscreenUpdate);
    htmlElement.addEventListener('webkitfullscreenchange', sendFullscreenUpdate);
    htmlElement.addEventListener('msfullscreenchange', sendFullscreenUpdate);
  }

  public handleToggleFullScreen() {
    if (window.parent === window.self) {
      toggleFullscreen();
    } else {
      this.rootStore.postMessageStore.sendParentMessage({
        name: FromGamePostMessage.PgToggleFullscreen
      });
    }
  }

}
